













import { Vue, Prop, Component } from 'vue-property-decorator';
import InvoicePaymentMethod from '@/domain/billing/entity/invoice-payment-link/invoice-payment-method';

const PAYMENT_TYPES = {
  CARD: 'Cartão',
  BANK_TRANSFER: 'Transferência bancária',
  TICKET: 'Ticket',
};

@Component
export default class PaymentCountrySelection extends Vue {
  @Prop({ type: InvoicePaymentMethod, required: true })
  item!: InvoicePaymentMethod;

  getName(name: string, type: string): string {
    if (!PAYMENT_TYPES[type]) return name;
    return `${name} (${PAYMENT_TYPES[type]})`;
  }
}

